import { useState } from 'react'

import { Box, Button, Text } from '@factorialco/deprecated-design-system'
import { AvailableModules, Features } from 'generated/featureDefinitions'

import Upgrade from 'modules/core/components/Upgrade'
import i18n from 'modules/core/lib/i18n'
import users from 'modules/core/store/collections/users'

import type { IBookingAvailability } from 'modules/space_control/hooks/useBookingLimits'
import RequestUpgradeModal from 'modules/upsell/components/RequestUpgradeModal'
import { ValidReasons } from 'modules/upsell/hooks/useCreateUpsellRequest'

interface Props {
  bookingAvailability: IBookingAvailability
}

const getBannerMessage = (bookingAvailability: IBookingAvailability) => {
  if (bookingAvailability.limitReached) {
    return i18n.t('space_control.pricing.banners.booking_limit_reached', {
      limit: bookingAvailability.usageLimit,
    })
  }
  return i18n.t('space_control.pricing.banners.booking_close_to_limit', {
    close: bookingAvailability.usage,
    limit: bookingAvailability.usageLimit,
  })
}

const BookingLimits = ({ bookingAvailability }: Props) => {
  const [isOpen, toggleOpen] = useState(false)

  const canCreateWorkSpace = users.current.policy.can('spaceControl.workSpaceCreate')

  const showBanner = !!(bookingAvailability.limitReached || bookingAvailability.closeToLimit)

  const banner = showBanner && (
    <Upgrade.Banner
      message={getBannerMessage(bookingAvailability)}
      button={
        canCreateWorkSpace && (
          <Button type="upgrade" onClick={() => toggleOpen(true)}>
            {i18n.t('packaging.upgrade_plan.buttons.know_more')}
          </Button>
        )
      }
    />
  )

  const modal = isOpen && (
    <RequestUpgradeModal
      moduleRequested={AvailableModules.space_control}
      featureRequested={Features.space_control_spaces}
      requestReason={ValidReasons.MissingFeatureLegacy}
      requestSource="Reached limit in number of available bookings"
      title={i18n.t('space_control.pricing.modal.title')}
      description={
        <Box gap="s16">
          <Text.Normal size="300" overflowWrap>
            {i18n.t('space_control.pricing.modal.description', {
              limit: bookingAvailability.usageLimit,
            })}
          </Text.Normal>
        </Box>
      }
      onClose={() => toggleOpen(false)}
    />
  )

  return (
    <>
      {banner}
      {modal}
    </>
  )
}

export default BookingLimits
